import { ArtistBalanceItemProps } from 'src/Components/ArtistBalanceItem'
import { formatDate } from 'src/Constants/formatDate'
import _dayjs from 'src/Helpers/dayjs'
import SpotifyIcon from 'src/Assets/Svg/artist-balance-icons/Spotify.svg?react'
import TiktokIcon from 'src/Assets/Svg/artist-balance-icons/TikTok.svg?react'
import { TransactionTypeEnum } from 'src/Types/payments'
import {
  capitalizeFirstLetter,
  getValueOrEmptyString,
} from 'src/Helpers/layoutHelpers'

import { ArtistBalanceHistoryHelper } from './helpers'

import { ArtistBalanceItem } from '.'

type ArtistBalanceHistoryGroupedByDate = {
  date: string
  items: ArtistBalanceItemProps[]
}

const formatArtistBalanceItem = (
  items: ArtistBalanceItem[],
): ArtistBalanceItemProps[] => {
  const formattedItems: ArtistBalanceItemProps[] = []

  const itemsWithCampaignId = []
  for (const item of items) {
    // push items without campaign id
    if (
      !item.campaignId ||
      item.transactionType === TransactionTypeEnum.RECEIVED ||
      item.transactionType === TransactionTypeEnum.CHARGEBACK
    ) {
      formattedItems.push(ArtistBalanceHistoryHelper.formatItemToProps(item))
    } else {
      itemsWithCampaignId.push(item)
    }
  }

  const groupedByCampaignId =
    ArtistBalanceHistoryHelper.groupedByCampaignId(itemsWithCampaignId)

  for (const group of groupedByCampaignId) {
    const newItem: ArtistBalanceItemProps = {
      id: group[0].id,
      bold: true,
      boldAmount: true,
      date: getValueOrEmptyString(group[0].createdAt),
      icon: group[0].platformType === 'spotify' ? SpotifyIcon : TiktokIcon,
      text: `${capitalizeFirstLetter(group[0].platformType)} campaign for "${group[0].track.trackName}" was launched`,
      positive: false,
      amount: ArtistBalanceHistoryHelper.calculateGroupedAmount(group),
      subItems: [],
    }
    for (const item of group) {
      const formattedItem = ArtistBalanceHistoryHelper.formatItemToProps(item)
      if (newItem.subItems && formattedItem.amount !== '$0.00') {
        newItem.subItems.push(formattedItem)
      }
    }
    formattedItems.push(newItem)
  }

  return formattedItems.sort((a, b) => {
    const dateADifference = new Date(a.date).getTime()
    const dateBDifference = new Date(b.date).getTime()
    return dateBDifference - dateADifference
  })
}

export const groupArtistBalanceHistoryByDate = (
  artistBalanceHistory?: ArtistBalanceItem[],
): ArtistBalanceHistoryGroupedByDate[] => {
  if (!artistBalanceHistory) {
    return []
  }
  const groupedHistory: { [key: string]: ArtistBalanceItem[] } = {}
  artistBalanceHistory.forEach((item) => {
    const date = _dayjs(item.createdAt).format(formatDate.formatDate1)
    if (!groupedHistory[date]) {
      groupedHistory[date] = []
    }
    groupedHistory[date].push(item)
  })
  return Object.entries(groupedHistory)
    .sort(([dateA], [dateB]) => {
      const dateADifference = new Date(dateA).getTime()
      const dateBDifference = new Date(dateB).getTime()
      return dateBDifference - dateADifference
    })
    .map(([date, items]) => ({
      date,
      items: formatArtistBalanceItem(items),
    }))
}
